module.exports = __webpack_public_path__ + "img/Folw.073e3ee4.png";